// Shared game math and outcome helpers
export const MAX_UNIT_LEVEL = 5;
// Math.floor(100 * 1.5 ^ (level - 1))
export function upgradeCost(level) {
    return Math.floor(100 * Math.pow(1.5, level - 1));
}
// winner is "side_a" | "side_b" | "draw"; side_a = player perspective
export function getOutcomeColor(winner) {
    if (winner === "side_a")
        return "#22c55e";
    if (winner === "draw")
        return "#f59e0b";
    return "#ef4444";
}
export function getOutcomeLabel(winner) {
    if (winner === "side_a")
        return "VICTORY";
    if (winner === "draw")
        return "DRAW";
    return "DEFEAT";
}
export function getOutcomeShort(winner) {
    if (winner === "side_a")
        return "W";
    if (winner === "draw")
        return "D";
    return "L";
}
export function getOutcomeEmoji(winner) {
    if (winner === "side_a")
        return "🏆";
    if (winner === "draw")
        return "⚖";
    return "💔";
}
